"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCountriesOptions = void 0;
var react_1 = require("react");
var useConfig_1 = require("../useConfig");
var next_intl_1 = require("next-intl");
var useCountries_1 = require("./useCountries");
var geo_1 = require("../geo");
var useCountriesOptions = function (_a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, _d = _c.applyGeoRestrictions, applyGeoRestrictions = _d === void 0 ? false : _d;
    var countriesData = (0, useCountries_1.useCountries)().data;
    var config = (0, useConfig_1.useConfig)();
    var geoData = (0, geo_1.useGeo)().data;
    var t = (0, next_intl_1.useTranslations)('country');
    return (0, react_1.useMemo)(function () {
        var _a, _b, _c, _d;
        var countries = (countriesData || []).map(function (item) { return ({
            label: t(item.code),
            value: String(item.code),
        }); });
        var currentGeo = (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode;
        var hiddenForOtherGeo = (applyGeoRestrictions &&
            ((_c = (_b = config === null || config === void 0 ? void 0 : config['countries']) === null || _b === void 0 ? void 0 : _b.hiddenForOtherGeo) === null || _c === void 0 ? void 0 : _c.filter(function (country) { return country !== currentGeo; }))) ||
            [];
        var excludedCountries = __spreadArray(__spreadArray([], (((_d = config === null || config === void 0 ? void 0 : config['countries']) === null || _d === void 0 ? void 0 : _d.blackList) || []), true), hiddenForOtherGeo, true);
        if (excludedCountries.length === 0)
            return countries;
        var blackListAsObj = excludedCountries.reduce(function (acc, item) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[item] = true, _a)));
        }, {});
        return countries.filter(function (country) { return !(blackListAsObj === null || blackListAsObj === void 0 ? void 0 : blackListAsObj[country.value]); });
    }, [
        t,
        countriesData,
        config,
        (_b = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _b === void 0 ? void 0 : _b.countryCode,
        applyGeoRestrictions,
    ]);
};
exports.useCountriesOptions = useCountriesOptions;
